export default {
    hadToken: false,
    token: "",
};
